module.exports = __webpack_public_path__ + "img/img8.576282c2.png";